import { createFileRoute } from "@tanstack/react-router";
import { Mail, MapPin, Phone } from "lucide-react";
import { SiteShell } from "@/project/components/site-shell";

export const Route = createFileRoute("/contact")({
  head: () => ({ meta: [{ title: "Contact — Animal Seva" }, { name: "description", content: "Get in touch with the Animal Seva team." }]}),
  component: Contact,
});

function Contact() {
  return (
    <SiteShell>
      <section className="mx-auto grid max-w-6xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--saffron-deep)]">Contact</p>
          <h1 className="mt-2 font-display text-4xl font-semibold text-[var(--maroon-deep)]">We'd love to hear from you</h1>
          <p className="mt-3 text-foreground/70">Donors, institutions, journalists and volunteers — drop us a note.</p>
          <ul className="mt-8 space-y-4 text-sm">
            <li className="flex gap-3"><Mail className="h-5 w-5 text-[var(--maroon)]" /> support@animalseva.example</li>
            <li className="flex gap-3"><Phone className="h-5 w-5 text-[var(--maroon)]" /> +91 1800 000 000</li>
            <li className="flex gap-3"><MapPin className="h-5 w-5 text-[var(--maroon)]" /> Ahmedabad, Gujarat, India</li>
          </ul>
          <div className="mt-8 h-48 rounded-2xl bg-[var(--cream-2)] grid place-items-center text-sm text-foreground/70">
            Map placeholder
          </div>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); alert("Thanks — we'll respond within 2 working days."); }}
              className="space-y-4 rounded-2xl border border-border/60 bg-card p-6 shadow-[var(--shadow-soft)]">
          <Field label="Full name" required />
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Email" type="email" required />
            <Field label="Mobile" />
          </div>
          <Field label="Subject" required />
          <label className="block">
            <span className="text-xs text-foreground/60">Message *</span>
            <textarea required rows={5} className="mt-1 w-full rounded-xl border border-border bg-background px-4 py-2.5 text-sm outline-none focus:border-[var(--maroon)]" />
          </label>
          <button type="submit" className="w-full rounded-full bg-[var(--maroon)] px-5 py-3 text-sm font-semibold text-[var(--cream)] hover:bg-[var(--maroon-deep)]">Send enquiry</button>
        </form>
      </section>
    </SiteShell>
  );
}

function Field({ label, type = "text", required }: { label: string; type?: string; required?: boolean }) {
  return (
    <label className="block">
      <span className="text-xs text-foreground/60">{label}{required && " *"}</span>
      <input type={type} required={required} className="mt-1 w-full rounded-xl border border-border bg-background px-4 py-2.5 text-sm outline-none focus:border-[var(--maroon)]" />
    </label>
  );
}